import TertiaryButton from 'components/TertiaryButton';
import { FallbackProps } from 'react-error-boundary';
import { StyledBox, Title, Illustration, SubTitle, BodyText } from './ErrorScreen.styles';

function ErrorPage({ resetErrorBoundary }: FallbackProps) {
  return (
    <StyledBox>
      <Title variant="h1">Oops!</Title>
      <Illustration />
      <SubTitle variant="h2">That wasn&apos;t meant to happen...</SubTitle>
      <BodyText variant="body1">There seems to be a problem loading this page.</BodyText>
      <TertiaryButton onClick={resetErrorBoundary}>Try Again</TertiaryButton>
    </StyledBox>
  );
}

export default ErrorPage;
